import { Controller } from "@hotwired/stimulus";
import { apiErrorMessage } from "utils/api_error_message";
import { seemsOffline } from "utils/connectivity";
import { clearLocalCaseProgress } from "utils/clear_local_case_progress";

// Connects to data-controller="reset-case"
export default class extends Controller {
  static targets = ["resetCaseButton"];
  static outlets = ["offline-navigation"];

  connect() {
    this.csrfToken = document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content");
  }

  reset = async (event) => {
    event.preventDefault();

    const btn = event.currentTarget;

    if (seemsOffline() && this.hasOfflineNavigationOutlet) {
      this.offlineNavigationOutlet.showFeatureUnavailable(btn);
      return;
    }

    if (
      !confirm(
        "Are you sure you want to reset this case?  This will delete all of your work so you can go through the case again. Your previous work will not show in reports."
      )
    ) {
      return;
    }

    btn.disabled = true;

    const url = btn.getAttribute("data-reset-url");

    localStorage.removeItem("lowTimeModal");

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "X-CSRF-Token": this.csrfToken,
          Accept: "application/json",
        },
        credentials: "same-origin",
      });

      if (response.ok) {
        await clearLocalCaseProgress();
        window.location.reload();
      } else {
        const data = await response.json().catch(() => null);

        alert("Reset failed: " + apiErrorMessage(data));
      }
    } catch (error) {
      console.error("Reset failed:", error);

      alert("Reset failed: Network error");
    } finally {
      btn.disabled = false;
    }
  };
}
